
import React from 'react';
import { Button } from '@/components/ui/button';
import { Coins } from 'lucide-react';

interface SubscriptionActionsProps {
  onBuyCredits: () => void;
}

const SubscriptionActions: React.FC<SubscriptionActionsProps> = ({
  onBuyCredits
}) => {
  return (
    <div className="flex gap-2">
      <Button 
        onClick={onBuyCredits}
        className="bg-green-500 hover:bg-green-600 flex items-center gap-2"
      >
        <Coins size={16} />
        Blej Më Shumë Kredite
      </Button>
    </div>
  );
};

export default SubscriptionActions;
